import { render, staticRenderFns } from "./SingleCourse.vue?vue&type=template&id=03a8017c&scoped=true"
import script from "./SingleCourse.vue?vue&type=script&lang=js"
export * from "./SingleCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8017c",
  null
  
)

export default component.exports